const testId = (name: string | undefined, context: string | undefined) => {
  if (!name) {
    return undefined
  }

  return `${context}.${name.replace(/ /g, '')}`
}

export default testId
